<template>
  <a-modal
    :title="$t('title.SupervisionCodeCollection')"
    v-model="visible"
    width="80%"
    style="height: 70%"
    centered
    ref="supervisionBarcode"
    :destroyOnClose="true"
    :maskClosable="false"
    footer=""
  >
    <a-row type="flex" align="bottom">
      <a-col :span="11">
        <a-input-search
          ref="supervise"
          :placeholder="$t('placeholder.scanSupervisionCode')"
          v-model="superviseBarcodeNo"
          :loading="collectLoading"
          @search="collect"
          enterButton />
        <br /> <br />
        <a-layout>
          <a-table
            style="height: 500px"
            :dataSource="commandData"
            :pagination="false"
            :loading="commandTableLoading"
            :rowSelection="{selectedRowKeys: selectedCommandKeys, onChange: onCommandSelectChange,type:'radio',columnWidth:'50px'}"
            :rowKey="record => record.command.id"
            size="small"
            :customRow="onClickCommandRow"
            :scroll="{ x: false,y:'150%'}"
            bordered>
            <a-table-column dataIndex="item.name" :title="$t('business.label.itemName')" :ellipsis="true" align="center">
              <a-tooltip :title="text" slot-scope="text">{{ text }}</a-tooltip>
            </a-table-column>
            <a-table-column dataIndex="item.no" :title="$t('business.label.itemNo')" :ellipsis="true" align="center">
              <a-tooltip :title="text" slot-scope="text">{{ text }}</a-tooltip>
            </a-table-column>
            <a-table-column dataIndex="pack.specification" :title="$t('business.label.specification')" :ellipsis="true" align="center">
              <a-tooltip :title="text" slot-scope="text">{{ text }}</a-tooltip>
            </a-table-column>
            <a-table-column dataIndex="lot.no" :title="$t('business.label.lot')" :ellipsis="true" align="center">
              <a-tooltip :title="text" slot-scope="text">{{ text }}</a-tooltip>
            </a-table-column>
            <a-table-column :title="$t('business.label.quantity')" align="center" dataIndex="command.quantity"></a-table-column>
          </a-table>
          <page-util
            :content-size="contentSize"
            :page="page"
            :size="size"
            @change="pageChange"
          />
        </a-layout>
      </a-col>
      <a-col :span="13">
        <a-divider>
          <span v-show="active" class="normalFont">{{ item.no + '_' + item.name + '_' + pack.specification + '_' + lot.no }}</span>
        </a-divider>
        <a-descriptions :column="4" style="margin-left: 10%;margin-top: -24px;margin-bottom: -15px">
          <a-descriptions-item>
            <span class="normalFont">{{ $t('business.label.SmallPackUnit') }}:</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <span class="normalFont">{{ pack.uom }}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <span class="normalFont">{{ smallLen }}/{{ quantity }}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <a-radio @focus="selectedRadio(true,false,false)" :checked="small"></a-radio>
          </a-descriptions-item>
          <a-descriptions-item>
            <span class="normalFont">{{ $t('business.label.QuantityOfInnerPack') }}:</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <span class="normalFont">{{ pack.innerFactor }}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <span class="normalFont">{{ middleLen }}/{{ quantity }}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <a-radio @focus="selectedRadio(false,true,false)" :checked="middle"></a-radio>
          </a-descriptions-item>
          <a-descriptions-item>
            <span class="normalFont">{{ $t('business.label.QuantityOfLargePack') }}:</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <span class="normalFont">{{ pack.factor }}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <span class="normalFont">{{ largeLen }}/{{ quantity }}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <a-radio @focus="selectedRadio(false,false,true)" :checked="large"></a-radio>
          </a-descriptions-item>
        </a-descriptions>
        <a-divider>{{ $t('business.label.scanned') }}</a-divider>
        <a-layout bordered>
          <a-table
            :dataSource="superviseData"
            :loading="superviseTableLoading"
            :rowSelection="{selectedRowKeys: selectedSuperviseKeys, onChange: onSuperviseSelectChange,type:'radio',columnWidth:'50px'}"
            :rowKey="record => record.barcode.no"
            size="small"
            :pagination="pagination"
            :customRow="onClickSuperviseRow"
            :scroll="{ x: false,y:260}"
            style="height: 350px"
            bordered>
            <a-table-column :title="$t('business.label.index')" width="60px">
              <span slot-scope="text, record, index">{{ index + 1 }}</span>
            </a-table-column>
            <a-table-column :title="$t('business.label.supervisionCode')" align="center" dataIndex="barcode.no" width="60%" />
            <a-table-column :title="$t('business.label.appearance')" align="center" dataIndex="barcode.appearance">
              <span slot-scope="text">{{ appearanceData.find(item => item.ordinal === text).name }}</span>
            </a-table-column>
            <a-table-column :title="$t('business.label.operate')" align="center">
              <a-tooltip :title="$t('business.label.deleteSupervisionCode')" slot-scope="text,record">
                <a-icon type="minus-circle" theme="twoTone" @click="remove(record)"></a-icon>
              </a-tooltip>
            </a-table-column>
          </a-table>
        </a-layout>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
import { findAll, findEnum, findOne, post } from '@/api/Api'
import PageUtil from '@/components/Pagination/PageUtil.vue'
import ColumnEditor from '@/components/Editor/ColumnEditor.vue'
import { Item } from '@/api/dto/common/Item'
import { Lot } from '@/api/dto/common/Lot'
import { Pack } from '@/api/dto/common/Pack'
import Api from '@/api'

export default {
  name: 'SupervisedModal',
  components: { ColumnEditor, PageUtil },
  data() {
    return {
      visible: false,
      commandData: [],
      superviseData: [],
      appearanceData: [],
      show: false,
      commandTableLoading: false,
      superviseTableLoading: false,
      collectLoading: false,
      selectedCommandKeys: [],
      selectedCommandRows: [],
      selectedSuperviseKeys: [],
      selectedSuperviseRows: [],
      contentSize: 0,
      page: 1,
      size: 10,
      pagination: {
        pageSizeOptions: ['5', '10', '15', '20', '50'],
        showSizeChanger: true,
        pageSize: 10
      },
      superviseBarcodeNo: null,
      no: '',
      args: null,
      item: new Item(),
      lot: new Lot(),
      pack: new Pack(),
      active: false,
      quantity: 0,
      small: false,
      middle: false,
      large: false,
      superviseCommandFactory: 'supervisionCommandShipmentFactory',
      superviseDataFactory: 'supervisionBarcodeShipmentFactory',
      smallLen: 0,
      middleLen: 0,
      largeLen: 0
    }
  },
  props: {
    type: {
      type: Number,
      default: 2
    }
  },
  mounted() {
    findEnum('Appearance').then(res => {
      if (res.success) {
        this.appearanceData = res.result
      }
    })
  },
  methods: {
    open(args) {
      this.data = []
      this.name = ''
      this.no = ''
      this.visible = true
      this.args = args
      if (this.type === 1) {
        this.superviseCommandFactory = 'supervisionCommandReceiptFactory'
        this.superviseDataFactory = 'supervisionBarcodeReceiptFactory'
      }
      this.startScan()
      this.getCommandData()
    },
    pageChange(e) {
      this.page = e.page
      this.size = e.size
      this.getCommandData()
    },
    onCommandSelectChange(selectedRowKeys, selectedRows) {
      this.selectedCommandKeys = selectedRowKeys
      this.selectedCommandRows = selectedRows
      this.item = selectedRows[0].item
      this.pack = selectedRows[0].pack
      this.lot = selectedRows[0].lot
      this.quantity = selectedRows[0].command.quantity
      this.active = true
      this.selectedRadio(true, false, false)
    },
    onSuperviseSelectChange(selectedRowKeys, selectedRows) {
      this.selectedSuperviseKeys = selectedRowKeys
      this.selectedSuperviseRows = selectedRows
    },
    getCommandData() {
      this.loading = true
      findAll(this.superviseCommandFactory, this.args, this.page, this.size)
        .then((res) => {
          if (res.success) {
            this.contentSize = res.contentSize
            this.commandData = res.result
            if (this.commandData.length > 0) {
              this.onCommandSelectChange([this.commandData[0].command.id], [this.commandData[0]])
            } else {
              const that = this
              this.$confirm({
                title: '当前单据或商品未查询到作业信息,无法采集监管码',
                content: '是否关闭采集界面?',
                onOk() {
                  that.visible = false
                },
                onCancel() {
                },
                centered: true
              })
            }
          }
        }).finally(() => {
        this.loading = false
      })
    },
    onClickCommandRow(record) {
      return {
        on: {
          click: () => {
            this.onCommandSelectChange([record.command.id], [record])
          }
        }
      }
    },
    onClickSuperviseRow(record) {
      return {
        on: {
          click: () => {
            this.onSuperviseSelectChange([record.barcode.no], [record])
          }
        }
      }
    },
    collect() {
      this.collectLoading = true
      const args = {
        id: this.selectedCommandKeys[0],
        no: this.superviseBarcodeNo,
        operationType: this.type,
        appearance: null
      }
      if (this.small) {
        args.appearance = 3
      }
      if (this.middle) {
        args.appearance = 2
      }
      if (this.large) {
        args.appearance = 1
      }
      post(Api.supervisingSave, {}, args).then(res => {
        if (res.success) {
          if (this.small) {
            this.smallLen++
          }
          if (this.middle) {
            this.middleLen = this.middleLen + this.pack.innerFactor
          }
          if (this.large) {
            this.largeLen = this.largeLen + this.pack.factor
          }
          this.superviseData.push({ barcode: { no: this.superviseBarcodeNo, appearance: args.appearance } })
        }
        this.startScan()
      }).finally(() => {
        this.collectLoading = false
      })
    },
    startScan() {
      this.superviseBarcodeNo = null
      this.$nextTick(() => {
        this.$refs.supervise.focus()
      })
    },
    selectedRadio(small, middle, large) {
      if (this.small) {
        if (this.smallLen + 1 > this.quantity) {
          return this.$message.warning('监管码采集数量超出')
        }
      }
      if (middle) {
        if (this.pack.innerFactor + this.middleLen > this.quantity) {
          return this.$message.warning('当前中包装数大于需采集数量,应采集小包装')
        }
      }
      if (large) {
        if (this.pack.factor + this.largeLen > this.quantity) {
          return this.$message.warning('当前包装数大于需采集数量,应采集中小包装')
        }
      }
      this.small = small
      this.middle = middle
      this.large = large
      this.getSuperviseData()
    },
    remove(record) {
      post(Api.supervisingDelete, {}, { no: record.no }).then(res => {
        if (res.success) {
          this.$message.success('删除成功')
          this.getSuperviseData()
        }
      })
    },
    getSuperviseData() {
      this.superviseTableLoading = true
      findOne(this.superviseDataFactory, { 'command.id': this.selectedCommandKeys[0] }).then(res => {
        if (res.success) {
          const result = res.result
          this.smallLen = result.small.length
          this.middleLen = result.middle.length * this.pack.innerFactor
          this.largeLen = result.large.length * this.pack.factor
          if (this.small) {
            this.superviseData = result.small
          }
          if (this.middle) {
            this.superviseData = result.middle
          }
          if (this.large) {
            this.superviseData = result.large
          }
          this.onSuperviseSelectChange([], [])
          this.startScan()
        }
      }).finally(() => this.superviseTableLoading = false)
    }
  }
}
</script>
<style scoped>
.normalFont {
  font-weight: bold;
  font-size: 18px;
  color: #404040;
}
</style>
